import React, { Component } from 'react';
import { connect } from 'react-redux';
import { buyerRegister } from '../../Action/registration';
import { withRouter } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { Link } from 'react-router-dom'
import { Header, Footer, LoginHeader } from '../Common';
import { GoogleLoginItem } from '../Login/GoogleLoginItem';
import { FacebookLoginItem } from '../Login/FacebookLoginItem';

class BuyerRegistration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: false,
            email: '',
            user_type: 1,
            errors: []
        };
        SimpleReactValidator.addLocale('klingon', {
            integer: '数字を入れてください.',
            max: ':attribute :max 文字以下にしてください .',
            required: ' :attribute を必須です.',
            min: ':attribute :min 文字以上にしてください .',
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors })
        }
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        e.preventDefault();
        document.getElementById("step1").disabled = true;
        e.preventDefault();
        if (this.validator.allValid()) {
            let data = {}
            data = {
                email: this.state.email,
            }
            console.log(data)
            this.props.buyerRegister(data, this.props.history);
        } else {
            this.validator.showMessages();
        }
    }

    render() {
        const { errors } = this.state.errors;
        return (
            <div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12" >
                            <div className="">
                                <LoginHeader />
                            </div>
                        </div>
                        <div className="mt-5">
                            <div className="col-md-12 tr_blank_big"></div>
                            <div className="">
                                <div className="row">
                                    <div className="col-md-4"> </div>
                                    <div className="col-md-4">
                                        <div className="big_text" style={{paddingBottom:'0px'}}><b>購入者新規登録</b></div>
                                        <div className="">
                                            <hr style={{marginBottom:'.5rem',marginTop:'0.5rem'}}/>
                                        </div>
                                        <div className="instruction">ここには会員登録いただくと、知識・スキルを自由に売り買いすることができます。登録には、1分もかかりません。</div>
                                        <div className="login_inputs form-group" style={{ height: '380px' }}>
                                            <form onSubmit={this.handleSubmit.bind(this)}>
                                                <span className="mb-2" style={{ color: "red" }} >{errors}</span>
                                                <div className="name_text"><b>メールアドレス</b></div>
                                                <input type="email" className="user_id_box form-control" placeholder="info@domain.com" value={this.state.email} onChange={this.updateValue.bind(this, "email")} onBlur={() => this.validator.showMessageFor('メールアドレス')} />
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    {this.validator.message('メールアドレス', this.state.email, 'required')}
                                                </span>
                                                <div>&nbsp;</div>
                                                <div className="input_name">
                                                    <button type="submit" id="step1" className="btn-lg button_size"
                                                        style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1" }}
                                                        onSubmit={this.handleSubmit.bind(this)} >
                                                        登録する
                                                    </button>
                                                </div>
                                            </form>
                                            <br/>
                                            <br/>
                                            <div className="">
                                                <GoogleLoginItem id={this.state.user_type} />
                                                <br />
                                                <FacebookLoginItem id={this.state.user_type} />
                                            </div>
                                        </div>
                                        <div className="remember_text">
                                            既に登録している方は
                                            <Link to={"/login"} className="blue_text">こちら</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-4"> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" mt-5" >
                    <div className=" mt-5">
                        <Footer />
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
    buyerRegister: state.buyerRegister,
    errors: state.errors,
});

BuyerRegistration = connect(mapStateToProps, { buyerRegister })(withRouter(BuyerRegistration));

export { BuyerRegistration };